import { render, staticRenderFns } from "./FundingProjectsMembers.vue?vue&type=template&id=61be24a2&"
import script from "./FundingProjectsMembers.vue?vue&type=script&lang=js&"
export * from "./FundingProjectsMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports